module.exports = __webpack_public_path__ + "img/genesis-loading.b089ab0b.gif";